import { CircleCheck } from 'lucide-react';

export const TaskIcon = CircleCheck;

export default TaskIcon;
